// Bundle landing pages (templates/product.bundle-*.liquid). Video, slider and strip code is the
// boss's original page script; the subscription price swap and TRY IT NOW handler are store wiring.
document.querySelectorAll('[data-mute]').forEach(function(b){b.addEventListener('click',function(){var v=b.parentNode.querySelector('video');v.muted=!v.muted;if(!v.muted)v.play();b.setAttribute('aria-label',v.muted?'Turn sound on':'Turn sound off');b.style.background=v.muted?'':'#00607C';});});
(function(){var vids=[].slice.call(document.querySelectorAll('.fs-vid--real video'));if(!vids.length)return;
var hover=window.matchMedia('(hover: hover) and (pointer: fine)').matches;
function play(v){vids.forEach(function(o){if(o!==v)o.pause();});var p=v.play();if(p&&p.catch)p.catch(function(){});}
vids.forEach(function(v){var f=v.parentNode;
v.addEventListener('play',function(){f.classList.add('is-playing');});
v.addEventListener('pause',function(){f.classList.remove('is-playing');});
if(hover){f.addEventListener('mouseenter',function(){play(v);});f.addEventListener('mouseleave',function(){v.pause();});}
f.addEventListener('click',function(e){if(e.target.closest('[data-mute]'))return;if(v.paused)play(v);else v.pause();});});
if('IntersectionObserver' in window){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting)e.target.pause();});},{threshold:0.25});vids.forEach(function(v){io.observe(v);});}})();
(function(){var tr=document.querySelector('[data-slides]');if(!tr)return;var th=[].slice.call(document.querySelectorAll('[data-th]')),n=tr.children.length,cur=0;
function go(i){i=(i+n)%n;tr.scrollTo({left:tr.children[i].offsetLeft-tr.children[0].offsetLeft,behavior:'smooth'});}
var pg=document.querySelector('[data-prog]');if(pg){pg.style.width=(100/n)+'%';}
function mark(){var w=tr.children[1]?tr.children[1].offsetLeft-tr.children[0].offsetLeft:tr.clientWidth;var i=Math.min(n-1,Math.round(tr.scrollLeft/w));if(pg)pg.style.transform='translateX('+(i*100)+'%)';if(i===cur)return;cur=i;th.forEach(function(b,k){b.classList.toggle('fs-th--on',k===i);if(k===i)b.setAttribute('aria-current','true');else b.removeAttribute('aria-current');});var a=th[i],p=a&&a.parentNode;if(p&&p.scrollWidth>p.clientWidth){var l=a.offsetLeft-p.offsetLeft,r=l+a.offsetWidth;if(l<p.scrollLeft)p.scrollTo({left:l,behavior:'smooth'});else if(r>p.scrollLeft+p.clientWidth)p.scrollTo({left:r-p.clientWidth,behavior:'smooth'});}}
tr.addEventListener('scroll',function(){window.requestAnimationFrame(mark);},{passive:true});
th.forEach(function(b){b.addEventListener('click',function(){go(+b.getAttribute('data-th'));});});
document.querySelectorAll('[data-nav]').forEach(function(b){b.addEventListener('click',function(){go(cur+(+b.getAttribute('data-nav')));});});
tr.addEventListener('keydown',function(e){if(e.key==='ArrowRight'){e.preventDefault();go(cur+1);}if(e.key==='ArrowLeft'){e.preventDefault();go(cur-1);}});})();
document.querySelectorAll('[data-scroll]').forEach(function(b){b.addEventListener('click',function(){var st=b.closest('.fs-wrap').querySelector('[data-strip]');st.scrollBy({left:st.clientWidth*0.8*(+b.getAttribute('data-scroll')),behavior:'smooth'});});});

// Subscription box: swap every price/savings figure (rendered by bundle-lp-buy) between sub and one-time.
(function(){var c=document.querySelector('[data-sub]');if(!c)return;
function u(){document.querySelectorAll('[data-full-text]').forEach(function(el){el.textContent=c.checked?el.getAttribute('data-sub-text'):el.getAttribute('data-full-text');});}
c.addEventListener('change',u);u();})();

// TRY IT NOW: clear cart, add this bundle (with the selling plan when the box is checked), go to checkout.
// The add is a programmatic form POST with return_to=/checkout: the Kaching cart app patches fetch and listens
// for submit events to open its drawer, and form.submit() fires neither, so the shopper goes straight to checkout.
(function(){
  var fs = document.querySelector('.fs[data-variant]');
  if (!fs) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false;

  // Back from checkout restores this page from bfcache; allow another click.
  window.addEventListener('pageshow', function () { busy = false; });

  function post(url, body) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (res) {
      if (!res.ok) throw new Error(url + ' ' + res.status);
      return res;
    });
  }

  document.querySelectorAll('[data-buy]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      if (busy) return;
      busy = true;
      var item = { id: Number(fs.dataset.variant), quantity: 1 };
      var sub = document.querySelector('[data-sub]');
      if (sub && sub.checked) item.selling_plan = Number(sub.value);
      // Only the Halloween template uses the drawer; preserve the other bundle flows.
      if (fs.querySelector('.hw-top')) {
        post('cart/add.js', { items: [item] })
          .then(function () {
            if (window.kachingCartApi && window.kachingCartApi.openCart) {
              window.kachingCartApi.openCart({ refetchCart: true });
            } else {
              window.location.href = root + 'cart';
            }
            busy = false;
          })
          .catch(function () {
            busy = false;
            window.alert('Something went wrong. Please try again.');
          });
        return;
      }
      post('cart/clear.js')
        .then(function () {
          var form = document.createElement('form');
          form.method = 'post';
          form.action = root + 'cart/add';
          item.return_to = '/checkout';
          Object.keys(item).forEach(function (name) {
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = name;
            input.value = item[name];
            form.appendChild(input);
          });
          document.body.appendChild(form);
          form.submit();
        })
        .catch(function () {
          busy = false;
          window.alert('Something went wrong. Please try again.');
        });
    });
  });
})();
